import { render } from "./SettingsTabDiagnoses.vue?vue&type=template&id=437af036&scoped=true"
import script from "./SettingsTabDiagnoses.vue?vue&type=script&lang=js"
export * from "./SettingsTabDiagnoses.vue?vue&type=script&lang=js"

import "./SettingsTabDiagnoses.vue?vue&type=style&index=0&id=437af036&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437af036"]])

export default __exports__